import { Container } from 'ui';
import { Theme as EmotionTheme, css } from '@emotion/react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Typography } from 'omakase';
import {
  additionalInfoTable,
  additionalInfoTableCell,
  additionalInfoTableRow,
  desktopAndSmallDesktopOnly,
  mobileOnly,
  pageTitle,
} from 'routes/legal/privacySpecificRouteCssDefs';
import { privacyPolicyLink, termsLink } from 'utils/legal/termsUtils';

const tableData = [
  {
    category: 'Basic Guest Information',
    use: 'Provide the Services; Business operations; Communicate with you; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Merchants; Service providers; Online advertising partners; Entities for legal purposes; Entities for business transactions',
    sharing: 'Online advertising partners',
  },
  {
    category: 'Guest Diner Profile Information',
    use: 'Provide the Services; Business operations; Communicate with you; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Merchants; Service providers; Entities for legal purposes; Entities for business transactions',
    sharing: 'We do not Share',
  },
  {
    category: 'Financial and transactional information',
    use: 'Provide the Services; Business operations; Communicate with you; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Merchants; Service providers; Entities for legal purposes; Entities for business transactions',
    sharing: 'We do not Share',
  },
  {
    category: 'Customer service interaction information (including support call recordings)',
    use: 'Business operations; Communicate with you; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Service providers; Entities for legal purposes; Entities for business transactions',
    sharing: 'We do not Share',
  },
  {
    category: 'Gift card information',
    use: 'Provide the Services; Business operations',
    thirdParties:
      'Affiliated entities; Service providers; Merchants; Entities for legal purposes; Entities for business transactions',
    sharing: 'We do not Share',
  },
  {
    category: `Information used to make a Booking on a Guest's behalf`,
    use: 'Provide the Services; Business operations; Communicate with you; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Merchants; Service providers; Online advertising partners; Entities for legal purposes; Entities for business transactions',
    sharing: 'We do not Share',
  },
  {
    category: 'Surveys and contest information',
    use: 'Business operations; Communicate with you; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Service providers; Entities for legal purposes; Entities for business transactions',
    sharing: 'We do not Share',
  },
  {
    category: 'Information about Merchant personnel',
    use: 'Provide the Services; Business operations; Communicate with you; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Merchants; Service providers; Online advertising partners; Entities for legal purposes; Entities for business transactions',
    sharing: 'Online advertising partners',
  },
  {
    category:
      'Information collected through automated technologies (including location information inferred from an IP address and network or device activity such as browsing history)',
    use: 'Provide the Services; Business operations; Marketing and advertising; Improve the Services; With your consent',
    thirdParties:
      'Affiliated entities; Service providers; Online advertising partners; Entities for legal purposes; Entities for business transactions',
    sharing: 'Online advertising partners',
  },
];

const frenchTableData = [
  {
    category: 'Renseignements de base sur les clients',
    use: `Fournir nos services; activités d'affaires; communiquer avec vous; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; marchands; fournisseurs de services; partenaires de publicité en ligne; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Partenaires de publicité en ligne',
  },
  {
    category: 'Renseignements de profil de client',
    use: `Fournir nos services; activités d'affaires; communiquer avec vous; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; marchands; fournisseurs de services; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Nous ne communiquons pas',
  },
  {
    category: 'Renseignements financiers et sur les transactions',
    use: `Fournir nos services; activités d'affaires; communiquer avec vous; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; marchands; fournisseurs de services; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Nous ne communiquons pas',
  },
  {
    category: `Renseignements sur les interactions avec le service à la clientèle (y compris les enregistrements d'appels de soutien)`,
    use: `Activités d'affaires; communiquer avec vous; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; fournisseurs de services; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Nous ne communiquons pas',
  },
  {
    category: 'Renseignements sur les cartes-cadeaux',
    use: `Fournir nos services; activités d'affaires`,
    thirdParties: `Entités affiliées; fournisseurs de services; marchands; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Nous ne communiquons pas',
  },
  {
    category: 'Renseignements utilisés pour effectuer une réservation pour un client',
    use: `Fournir nos services; activités d'affaires; communiquer avec vous; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; marchands; fournisseurs de services; partenaires de publicité en ligne; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Nous ne communiquons pas',
  },
  {
    category: 'Renseignements sur sondage et concours',
    use: `Activités d'affaires; communiquer avec vous; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; fournisseurs de services; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Nous ne communiquons pas',
  },
  {
    category: 'Renseignements sur le personnel des marchands',
    use: `Fournir nos services; activités d'affaires; communiquer avec vous; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; marchands; fournisseurs de services; partenaires de publicité en ligne; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Partenaires de publicité en ligne',
  },
  {
    category: `Renseignements recueillis par des technologies automatisées (y compris les renseignements sur l'emplacement déduits en raison de l'adresse IP et le réseau, ou les activités sur l'appareil comme l'historique de navigation)`,
    use: `Fournir nos services; activités d'affaires; marketing et publicité; améliorer nos services; avec votre consentement`,
    thirdParties: `Entités affiliées; fournisseurs de services; partenaires de publicité en ligne; entités à des fins de respect de la loi; entités pour transactions d'affaires`,
    sharing: 'Partenaires de publicité en ligne',
  },
];

const PrivacySpecificRoute: React.FunctionComponent = () => {
  const effectiveDate = 'November 24, 2025';
  const frenchEffectiveDate = '24 novembre 2025';
  return (
    <div className="Legal">
      <Container maxWidth="md">
        <Typography css={pageTitle} component="h1" variant="heading01" align="center" mb={4}>
          Specific Privacy Notices
        </Typography>
        <Typography variant="body01Strong" mb={2}>
          Effective Date: {effectiveDate}
        </Typography>
        <Typography variant="body02" paragraph mb={2}>
          This specific privacy notices page is an extension to and forms part of the{' '}
          {privacyPolicyLink('Tock Privacy Policy')}. Capitalized terms used on this page shall have
          the meanings in the {privacyPolicyLink('Tock Privacy Policy')} or{' '}
          {termsLink('Tock Terms of Use')}.
        </Typography>

        <Typography component="h2" variant="heading02" mb={2}>
          Additional Information for Residents of Certain Jurisdictions
        </Typography>

        <Typography variant="body02">
          <i>Information for California Residents</i>
        </Typography>

        <Typography variant="body02" paragraph mb={2}>
          This Section is only applicable to you if you are a resident of the state of California
          (“California Residents”), whose personal information is subject to the California consumer
          Privacy Act ("CCPA") and is not otherwise subject to the Gramm-Leach-Bliley Act. This
          Section I covers Tock Controlled PI we collect about California Residents on or through
          our Services and through other means.
        </Typography>
        <Typography variant="body02" paragraph mb={2}>
          If you are a California Resident who is a Guest and has used the Services to make a
          Booking (or has had a booking made on their behalf by a concierge or Merchant), to learn
          about a Merchant's data practices with respect to Merchant Controlled PI, please visit
          such Merchant's Merchant Page or website or contact them directly.
        </Typography>

        <Typography
          component="ol"
          css={(theme: EmotionTheme) => css`
            list-style-type: lower-alpha;
            list-style-position: inside;
            margin-left: ${theme.spacing(4)}px;
          `}
        >
          <Typography component="li" variant="body02">
            <Typography component="span" variant="body01Strong">
              Categories, business and commercial purposes, sources and third parties
            </Typography>
            <br />
            <br />
            <Typography variant="body02">
              California law requires us to disclose certain information regarding the personal
              information we collect. Below is a table showing: (i) all categories of personal
              information which Tock collects, or has collected, about California Residents, in the
              preceding twelve (12) months prior to the effective date of this privacy specific
              notices page; (ii) the purposes for which we use that information; and (iii) the
              categories of third parties to whom we disclose personal information.
            </Typography>
            <TableContainer>
              <Table aria-label="simple table" css={additionalInfoTable}>
                <TableHead css={additionalInfoTableRow}>
                  <TableRow>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Category of personal information
                    </TableCell>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Purposes of use
                    </TableCell>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Categories of third parties to whom Tock discloses this personal information
                    </TableCell>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Categories of third parties with whom Tock “Shares” this personal information
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody css={additionalInfoTableRow}>
                  {tableData.map((data) => (
                    <TableRow>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.category}
                      </TableCell>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.use}
                      </TableCell>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.thirdParties}
                      </TableCell>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.sharing}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <br />
            {/* <Typography variant="body02" paragraph mb={2}>
              For more information about each category, purpose of use, and the third parties to
              whom we disclose or share information, please see our {privacyPolicyLink()}.
            </Typography> */}
            <Typography variant="body02" paragraph mb={2}>
              For information on how we retain your personal information, please see Section 9 (“How
              we retain your personal information”) of the {privacyPolicyLink()}.
            </Typography>
          </Typography>

          <Typography component="li">
            <Typography component="span" variant="body01Strong">
              Your requests
            </Typography>
            <br />
            <br />
            <Typography variant="body02">
              Subject to certain exceptions and restrictions, California Residents have the right to
              submit requests to a business which has collected their personal information: (i) to
              provide them with access to the specific pieces and categories of personal information
              collected by the business about such California Resident, the categories of sources
              for such information, the business or commercial purposes for collecting such
              information, and the categories of third parties with which such information was
              disclosed; (ii) to request correction of their inaccurate personal information; and
              (iii) to delete their personal information (each, a “California Request”). If you ask
              us to delete some or all of your information, you may no longer be able to access or
              use the Services as we need certain types of information so that we can provide our
              Services to you.
            </Typography>
            <Typography variant="body02">
              If you are a California Resident, please follow the instructions in the “Your rights
              and choices” section in our Privacy Policy to submit California Requests and please
              make sure you note that you are a California Resident when you do so. California
              Residents may designate an authorized agent to make California Requests on their
              behalf. In order to designate an authorized agent to make a California Request on your
              behalf, you or your agent must provide proof that the agent has been authorized by you
              to act on your behalf, such as written authorization signed by you authorizing that
              agent to act on your behalf. We reserve the right to request additional information
              from you and/or individuals purporting to be authorized agents, such as when we
              suspect fraud.
            </Typography>
          </Typography>
          <Typography component="li">
            <Typography component="span" variant="body01Strong">
              Do not sell or share my personal information
            </Typography>
            <br />
            <br />
            <Typography variant="body02" css={desktopAndSmallDesktopOnly}>
              California residents have the right to opt out of the "Sale" or “Sharing” (as defined
              in the CCPA) of their personal information. Tock does not Sell your personal
              information. The CCPA defines the "Sale" of personal information as, broadly speaking,
              disclosing personal information in exchange for monetary or other valuable
              consideration. It defines "Sharing” as disclosing personal information for purposes of
              “cross-context behavioral advertising,” which is defined, generally, as targeting of
              advertising to a consumer based on that consumer's personal information obtained from
              the consumer's activity across websites. We may Share information about your Internet
              activity and other personal information with third parties to provide more relevant
              and tailored advertising to you regarding our Services. Depending on how you use the
              Services, we may Share the following categories of information for such purposes: (i)
              identification and demographics; (ii) device information and identifiers, such as IP
              address and unique advertising identifiers and cookies; (iii) connection and usage
              information, such as browsing history or app usage; and (iv) inference data. Please
              note that we are only referencing the CCPA definition of “share” or “sharing” when
              those terms are capitalized on this page or in our Privacy Policy. If you would like
              to opt out of Tock's Sharing of your information with third parties for such purposes,
              you may do so by clicking on the “Your Privacy Choices” link in the footer of this
              page.
            </Typography>
            <Typography variant="body02" css={mobileOnly}>
              California residents have the right to opt out of the "Sale" or “Sharing” (as defined
              in the CCPA) of their personal information. Tock does not Sell your personal
              information. The CCPA defines the "Sale" of personal information as, broadly speaking,
              disclosing personal information in exchange for monetary or other valuable
              consideration. It defines "Sharing” as disclosing personal information for purposes of
              “cross-context behavioral advertising,” which is defined, generally, as targeting of
              advertising to a consumer based on that consumer's personal information obtained from
              the consumer's activity across websites. We may Share information about your Internet
              activity and other personal information with third parties to provide more relevant
              and tailored advertising to you regarding our Services. Depending on how you use the
              Services, we may Share the following categories of information for such purposes: (i)
              identification and demographics; (ii) device information and identifiers, such as IP
              address and unique advertising identifiers and cookies; (iii) connection and usage
              information, such as browsing history or app usage; and (iv) inference data. Please
              note that we are only referencing the CCPA definition of “share” or “sharing” when
              those terms are capitalized on this page or in our Privacy Policy. If you would like
              to opt out of Tock's Sharing of your information with third parties for such purposes,
              you may do so by clicking on the “Your Privacy Choices” menu item in the menu
              accessible from the upper-right corner of this page.
            </Typography>
            <Typography variant="body02">
              The CCPA also allows you to limit the use or disclosure of your “sensitive personal
              information” (as defined in the CCPA) if your sensitive personal information is used
              for certain purposes. Please note that we do not use or disclose sensitive personal
              information other than for purposes for which you cannot opt out under the CCPA. We
              respond to browser-initiated Do Not Track signals. Please note that Do Not Track is a
              different privacy mechanism than the “Global Privacy Control,” which is a
              browser-based control that indicates whether you would like to opt out of processing
              of your personal information for online behavioral advertising purposes. We respond to
              the Global Privacy Control in California. To opt out of Sharing, turn on the Global
              Privacy Control signal in your browser. Please note that the opt out will only apply
              to the browser and device you use to send the Global Privacy Control signal.
            </Typography>
            <Typography variant="body02">
              We do not knowingly “Sell or Share" the personal information of children under 16.
            </Typography>
          </Typography>
          <Typography component="li">
            <Typography component="span" variant="body01Strong">
              We do not discriminate against you
            </Typography>
            <br />
            <br />
            <Typography variant="body02">
              You also have the right to not be discriminated against (as provided for in applicable
              law) for exercising certain of your rights. Tock does not discriminate against
              California Residents for exercising their rights.
            </Typography>
          </Typography>
        </Typography>

        <Typography variant="body02">
          <i>Information for Australian Residents</i>
        </Typography>

        <Typography variant="body02">Cross-Border Transfers of Personal Information</Typography>

        <Typography variant="body02">
          Tock and its service providers are located in Australia and other jurisdictions, including
          Canada, the European Economic Area (EEA) and the United Kingdom, and the United States.
          Laws in other jurisdictions may differ from the laws where you reside. We and our service
          providers may disclose your personal information if we are required or permitted by
          applicable law or legal process, which may include lawful access by foreign courts, law
          enforcement or other government authorities in the jurisdictions in which we or our
          service providers operate. For information about how we or our service providers treat
          personal information, please contact us as set out in the "How to contact us" section of
          this {privacyPolicyLink()}.
        </Typography>

        <Typography variant="body02">Your Data Rights</Typography>

        <Typography variant="body02">
          Individuals who reside in Australia have a right to access, update, and change or correct
          your personal information. If you want to execute your data rights or if you have any
          questions about how we process your personal information, please contact us as set out in
          the "How to contact us" section of this {privacyPolicyLink()}.
        </Typography>

        <Typography variant="body02">
          <i>Information for Canadian Residents</i>
        </Typography>

        <Typography variant="body02">Cross-Border Transfers of Personal Information</Typography>

        <Typography variant="body02">
          Tock and its service providers are located both in Canada (including both within and
          outside of Quebec) and in other jurisdictions, including Australia, the European Economic
          Area (EEA) and the United Kingdom, and the United States. Laws in other jurisdictions may
          differ from the laws where you reside. We and our service providers may disclose your
          personal information if we are required or permitted by applicable law or legal process,
          which may include lawful access by foreign courts, law enforcement or other government
          authorities in the jurisdictions in which we or our service providers operate. For
          information about how we or our service providers treat personal information, please
          contact us as set out in the "How to contact us" section of this {privacyPolicyLink()}.
        </Typography>

        <Typography variant="body02">Your Data Rights</Typography>

        <Typography variant="body02">
          Subject to limited exceptions under applicable law, you have the right to access, update,
          and correct inaccuracies in your personal information in our custody and control, and to
          withdraw your consent to our collection, use, or disclosure, of your personal information
          (subject to legal and contractual restrictions). You may request access, updating, and
          corrections of inaccuracies in your personal information in our custody or control, or
          withdraw your consent, by contacting us as set out in the "How to contact us" section of
          this {privacyPolicyLink()}.
        </Typography>

        <Typography variant="body02">
          <i>Information for Residents of the European Economic Area (EEA) and United Kingdom</i>
        </Typography>

        <Typography variant="body02">Your Data Rights</Typography>

        <Typography variant="body02">
          Data Subjects in the EEA and the United Kingdom are provided certain legal rights
          regarding your personal information, including the right to:
        </Typography>

        <Typography component="ul">
          <Typography component="li">
            request details on or access to the personal information we have about you;
          </Typography>
          <Typography component="li">
            restrict and/or object to the use of personal information;
          </Typography>
          <Typography component="li">
            request the deletion of your personal information, under certain circumstances;
          </Typography>
          <Typography component="li">
            request a manual review of certain automated processing activities that may impact your
            legal or other contractual rights, or similarly affects you;
          </Typography>
          <Typography component="li">
            correct of the personal information we have about you;
          </Typography>
          <Typography component="li">
            receive your personal information in a structured, commonly used and machine-readable
            format and/or transmit such data to another data controller; and
          </Typography>
          <Typography component="li">
            withdraw the consent you have given for the processing of personal information at any
            time.
          </Typography>
        </Typography>

        <Typography variant="body02">
          If you want to execute your data rights or if you have any questions about how we process
          your personal information, plaese contact us as set out in the "How to contact us" section
          of this {privacyPolicyLink()}
        </Typography>
        {/* Begin french translation*/}
        <Typography component="h1" variant="heading03">
          Avis spéciaux concernant la confidentialité
        </Typography>
        <Typography variant="body01Strong" align="left">
          Date de prise d'effet: {frenchEffectiveDate}
        </Typography>

        <Typography variant="body02">
          La page d'avis spéciaux concernant la confidentialité est une prolongation et fait partie
          de la Politique de confidentialité de Tock. Les termes clés figurant sur cette page ont le
          sens qui leur est attribué dans la Politique de confidentialité de Tock ou dans les
          Conditions d'utilisation de Tock.
        </Typography>

        <Typography component="h2" variant="heading02">
          Renseignements supplémentaires pour résidents de certains territoires
        </Typography>

        <Typography variant="body02">
          <i>Renseignements pour résidents de la Californie</i>
        </Typography>

        <Typography variant="body02">
          La présente section est seulement applicable aux personnes qui résident en Californie
          (ci-après les « résidents de la Californie »), et dont les renseignements personnels sont
          soumis à la California Consumer Privacy Act (« CCPA ») et ne sont pas autrement soumis à
          la Gramm-Leach-Bliley Act. Cette section concerne les renseignements personnels contrôlés
          par Tock que nous recueillons sur les résidents de la Californie dans ou par l'entremise
          de nos services et par d'autres moyens.
        </Typography>

        <Typography variant="body02">
          Si vous résidez en Californie et êtes un client ou une cliente qui a utilisé nos services
          pour effectuer une réservation (ou pour qui une réservation a été effectuée par un service
          de conciergerie ou un marchand), pour en savoir plus sur les pratiques concernant les
          données ayant trait aux renseignements personnels contrôlés par un marchand, veuillez
          visiter le site Web du marchand en question ou communiquer directement avec ce dernier.
        </Typography>
        <Typography
          component="ol"
          css={(theme: EmotionTheme) => css`
            list-style-type: lower-alpha;
            list-style-position: inside;
            margin-left: ${theme.spacing(4)}px;
          `}
        >
          <Typography component="li" variant="body02">
            <Typography component="span" variant="body01Strong">
              Catégories, utilisations d'affaires et commerciales, sources et tiers
            </Typography>
            <br />
            <br />
            <Typography variant="body02">
              La législation californienne exige que nous divulguions certains renseignements
              concernant les renseignements personnels que nous recueillons. Le tableau ci-dessous
              indique : i) toutes les catégories de renseignements personnels que Tock recueille au
              sujet des résidents de la Californie au cours des douze (12) mois précédents; ii) les
              fins auxquelles nous utilisons ces renseignements; et iii) les catégories de tiers à
              qui nous divulguons des renseignements personnels.
            </Typography>
            <TableContainer>
              <Table aria-label="simple table" css={additionalInfoTable}>
                <TableHead css={additionalInfoTableRow}>
                  <TableRow>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Catégorie de renseignements personnels
                    </TableCell>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Fins d'utilisation
                    </TableCell>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Catégories de tiers à qui Tock divulgue ces renseignements personnels
                    </TableCell>
                    <TableCell align={'center'} css={additionalInfoTableCell}>
                      Catégories de tiers à qui Tock communique ces renseignements personnels
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody css={additionalInfoTableRow}>
                  {frenchTableData.map((data) => (
                    <TableRow>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.category}
                      </TableCell>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.use}
                      </TableCell>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.thirdParties}
                      </TableCell>
                      <TableCell align={'center'} css={additionalInfoTableCell}>
                        {data.sharing}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <br />
            <Typography variant="body02" paragraph mb={2}>
              Pour en savoir plus les façons dont nous conservons vos renseignements personnels,
              veuillez consulter la section 9 (« Comment nous conservons vos renseignements
              personnels ») de la {privacyPolicyLink('Politique de confidentialité')}.
            </Typography>
          </Typography>

          <Typography component="li">
            <Typography component="span" variant="body01Strong">
              Vos demandes
            </Typography>
            <br />
            <br />
            <Typography variant="body02">
              Sous réserve de certaines exceptions et restrictions, les résidents de la Californie
              ont le droit de soumettre des demandes à une entreprise qui a recueilli de leurs
              renseignements personnels : i) pour leur donner accès aux pièces et catégories
              précises de renseignements personnels recueillis par l'entreprise à leur sujet, aux
              catégories de sources de tels renseignements, aux fins d'affaires ou commerciales de
              la collecte de tels renseignements, et aux catégories de tiers auxquels de tels
              renseignements ont été divulgués; ii) pour demander la correction de leurs
              renseignements personnels inexacts; et iii) pour supprimer leurs renseignements
              personnels (chacune ci-après une « demande californienne »). Si vous nous demandez de
              supprimer une partie ou l'entièreté de vos renseignements, vous pourriez ne plus
              pouvoir accéder ni utiliser nos services, car nous avons besoin de certains types de
              renseignements pour vous fournir nos services.
            </Typography>
            <Typography variant="body02">
              Si vous résidez en Californie, veuillez suivre les directives présentées à la section
              « Vos droits et choix » de notre Politique de confidentialité afin de soumettre une
              demande californienne, et veuillez bien indiquer que vous résidez en Californie. Les
              résidents de la Californie peuvent désigner un représentant autorisé pour soumettre
              des demandes californiennes en leur nom. Afin de désigner un représentant autorisé
              pour soumettre une demande californienne à votre nom, vous ou votre représentant devez
              fournir une preuve que le représentant est autorisé à agir en votre nom, comme une
              autorisation signée par vous autorisant ce représentant à agir en votre nom. Nous nous
              réservons le droit de demander d'autres renseignements de votre part et (ou) de toute
              personne affirmant être votre représentant autorisé, comme lorsque nous suspectons une
              fraude.
            </Typography>
          </Typography>
          <Typography component="li">
            <Typography component="span" variant="body01Strong">
              Ne vendez ou ne communiquez pas mes renseignements personnels
            </Typography>
            <br />
            <br />
            <Typography variant="body02" css={desktopAndSmallDesktopOnly}>
              Les résidents de la Californie ont le droit de refuser que leurs renseignements
              personnels soient vendus ou communiqués (selon la définition dans la CCPA). Tock ne
              vend pas vos renseignements personnels. Dans la CCPA, le terme « vente » (« sale »)
              est défini généralement comme la divulgation de renseignements personnels en échange
              d'argent ou d'autre contrepartie ayant une valeur. Toujours dans la CCPA, le terme «
              communication » (« sharing ») est défini comme la divulgation de renseignements
              personnels à des fins de publicité comportementale contextuelle croisée, qui est une
              publicité ciblant un consommateur en fonction de renseignements personnels sur ce
              consommateur, tirés de ses activités sur plusieurs sites Web. Nous pouvons communiquer
              des renseignements au sujet de vos activités sur Internet et d'autres renseignements
              personnels à des tiers afin de vous présenter des publicités plus pertinentes et
              personnalisées concernant nos services. En fonction de votre utilisation de nos
              services, nous pouvons communiquer les catégories suivantes de renseignements à de
              telles fins : i) identification et analyses démographiques; ii) renseignements et
              identifiants d'appareils, comme une adresse IP ou des identifiants et des témoins
              publicitaires uniques; iii) renseignements sur la connexion et l'utilisation, comme
              votre historique de navigation ou votre utilisation d'applications; et iv) des données
              inférées. Veuillez noter que la définition de « communication » (« sharing ») et de «
              communiquer » (« share ») de la CCPA ne s'applique qu'à la présente section pour
              résidents de la Californie. Pour refuser que Tock communique vos renseignements à des
              tiers aux fins susmentionnées, cliquez sur le lien « Your Privacy Choices » dans le
              pied de cette page.
            </Typography>
            <Typography variant="body02" css={mobileOnly}>
              Les résidents de la Californie ont le droit de refuser que leurs renseignements
              personnels soient vendus ou communiqués (selon la définition dans la CCPA). Tock ne
              vend pas vos renseignements personnels. Dans la CCPA, le terme « vente » (« sale »)
              est défini généralement comme la divulgation de renseignements personnels en échange
              d'argent ou d'autre contrepartie ayant une valeur. Toujours dans la CCPA, le terme «
              communication » (« sharing ») est défini comme la divulgation de renseignements
              personnels à des fins de publicité comportementale contextuelle croisée, qui est une
              publicité ciblant un consommateur en fonction de renseignements personnels sur ce
              consommateur, tirés de ses activités sur plusieurs sites Web. Nous pouvons communiquer
              des renseignements au sujet de vos activités sur Internet et d'autres renseignements
              personnels à des tiers afin de vous présenter des publicités plus pertinentes et
              personnalisées concernant nos services. En fonction de votre utilisation de nos
              services, nous pouvons communiquer les catégories suivantes de renseignements à de
              telles fins : i) identification et analyses démographiques; ii) renseignements et
              identifiants d'appareils, comme une adresse IP ou des identifiants et des témoins
              publicitaires uniques; iii) renseignements sur la connexion et l'utilisation, comme
              votre historique de navigation ou votre utilisation d'applications; et iv) des données
              inférées. Veuillez noter que la définition de « communication » (« sharing ») et de «
              communiquer » (« share ») de la CCPA ne s'applique qu'à la présente section pour
              résidents de la Californie. Pour refuser que Tock communique vos renseignements à des
              tiers aux fins susmentionnées, cliquez sur le menu « Your Privacy Choices » accessible
              depuis le menu dans le coin supérieur droit de cette page.
            </Typography>
            <Typography variant="body02">
              La CCPA vous permet également de limiter l'utilisation et la divulgation de vos «
              renseignements personnels sensibles » (« sensitive personal information »), terme qui
              est défini dans la CCPA, si vos renseignements personnels sensibles sont utilisés à
              certaines fins. Veuillez noter que nous n'utilisons et ne divulguons pas de
              renseignements personnels sensibles à des fins autres que celles que vous pouvez
              refuser conformément à la CCPA. Nous répondons au signal « Global Privacy Control » en
              Californie. Pour refuser la communication de vos renseignements, activez le signal «
              Global Privacy Control » dans votre navigateur. Veuillez noter que le refus
              s'appliquera uniquement au navigateur et à l'appareil que vous utilisez pour
              transmettre le signal « Global Privacy Control ».
            </Typography>
            <Typography variant="body02">
              Nous ne « vendons ou communiquons » pas sciemment les renseignements personnels
              d'enfants de moins de 16 ans.
            </Typography>
          </Typography>
          <Typography component="li">
            <Typography component="span" variant="body01Strong">
              Nous ne faisons pas de discrimination à votre égard
            </Typography>
            <br />
            <br />
            <Typography variant="body02">
              Vous avez aussi le droit de ne pas faire l'objet de discrimination (comme prévu par
              les lois applicables) pour l'exercice de certains de vos droits. Tock ne fait pas de
              discrimination à l'égard des résidents de la Californie pour l'exercice de leurs
              droits.
            </Typography>
          </Typography>
        </Typography>

        <Typography variant="body02">
          <i>Renseignements pour résidents de l'Australie</i>
        </Typography>

        <Typography variant="body02">
          Transferts transfrontaliers de renseignements personnels
        </Typography>

        <Typography variant="body02">
          Tock et ses fournisseurs de services sont en Australie et dans d'autres territoires, y
          compris le Canada, l'Espace économique européen et le Royaume-Uni, et les États-Unis. Les
          lois des autres territoires peuvent être différentes des lois de votre lieu de résidence.
          Nos fournisseurs de services et nous pouvons divulguer vos renseignements personnels si
          les lois applicables ou des processus judiciaires l'exigent ou l'autorisent, ce qui
          signifie que des tribunaux, des organismes d'application de la loi ou d'autres organismes
          gouvernementaux dans les territoires où nous ou nos fournisseurs de services menons nos
          activités pourraient légalement accéder à vos renseignements. Pour en savoir plus sur les
          façons dont nous et nos fournisseurs de services traitons les renseignements personnels,
          veuillez communiquer avec nous aux coordonnées indiquées à la section « Comment
          communiquer avec nous » de la présente Politique de confidentialité.
        </Typography>

        <Typography variant="body02">Vos droits liés aux données</Typography>

        <Typography variant="body02">
          Les particuliers qui résident en Australie ont le droit d'obtenir, de mettre à jour, de
          modifier ou de corriger leurs renseignements personnels. Si vous voulez exercer vos droits
          liés aux données ou si vous avez des questions sur les façons dont nous traitons vos
          renseignements personnels, veuillez communiquer avec nous comme indiqué à la section «
          Comment communiquer avec nous » de la présente Politique de confidentialité.
        </Typography>

        <Typography variant="body02">
          <i>Renseignements pour résidents du Canada</i>
        </Typography>

        <Typography variant="body02">
          Transferts transfrontaliers de renseignements personnels
        </Typography>

        <Typography variant="body02">
          Tock et ses fournisseurs de services sont au Canada (y compris au Québec et hors du
          Québec) et dans d'autres territoires, y compris l'Australie, l'Espace économique européen
          et le Royaume-Uni, et les États-Unis. Les lois des autres territoires peuvent être
          différentes des lois de votre lieu de résidence. Nos fournisseurs de services et nous
          pouvons divulguer vos renseignements personnels si les lois applicables ou des processus
          judiciaires l'exigent ou l'autorisent, ce qui signifie que des tribunaux, des organismes
          d'application de la loi ou d'autres organismes gouvernementaux dans les territoires où
          nous ou nos fournisseurs de services menons nos activités pourraient légalement accéder à
          vos renseignements. Pour en savoir plus sur les façons dont nous et nos fournisseurs de
          services traitons les renseignements personnels, veuillez communiquer avec nous aux
          coordonnées indiquées à la section « Comment communiquer avec nous » de la présente
          Politique de confidentialité.
        </Typography>

        <Typography variant="body02">Vos droits liés aux données</Typography>

        <Typography variant="body02">
          Sous réserve de certaines exceptions prévues par les lois applicables, vous avez le droit
          d'obtenir, de modifier et de corriger vos renseignements personnels que nous détenons ou
          contrôlons, et de retirer votre consentement à notre collecte, utilisation ou divulgation
          de vos renseignements personnels (sous réserve de restrictions légales et contractuelles).
          Pour demander l'accès à vos renseignements personnels que nous détenons ou contrôlons, ou
          leur modification ou leur correction, ou pour retirer votre consentement, vous pouvez
          communiquer avec nous comme indiqué à la section « Communiquer avec nous » de la présente
          Politique de confidentialité. Nous pourrions demander certains renseignements personnels
          pour confirmer votre identité. Si vous voulez exercer vos droits liés aux données ou si
          vous avez des questions sur les façons dont nous traitons vos renseignements personnels,
          veuillez communiquer avec nous comme indiqué à la section « Comment communiquer avec nous
          » de la présente Politique de confidentialité.
        </Typography>

        <Typography variant="body02">
          <i>Renseignements pour les résidents de l'Espace économique européen et du Royaume-Uni</i>
        </Typography>

        <Typography variant="body02">Vos droits liés aux données</Typography>

        <Typography variant="body02">
          Les sujets de données de l'Espace économique européen et du Royaume-Uni ont certains
          droits prévus par la loi concernant leurs renseignements personnels, dont le droit de :
        </Typography>
        <Typography component="ul">
          <Typography component="li">
            demander des détails sur les renseignements personnels que nous avons à leur sujet ou
            demander l'accès à ces renseignements;
          </Typography>
          <Typography component="li">
            restreindre l'utilisation des renseignements personnels ou s'y opposer;
          </Typography>
          <Typography component="li">
            demander la suppression de leurs renseignements personnels dans certaines circonstances;
          </Typography>
          <Typography component="li">
            demander un examen manuel de certaines activités de traitement automatisé qui pourraient
            avoir des répercussions sur leurs droits prévus par la loi ou d'autres droits
            contractuels, ou qui ont une incidence similaire sur eux;
          </Typography>
          <Typography component="li">
            corriger les renseignements personnels que nous avons à leur sujet;
          </Typography>
          <Typography component="li">
            recevoir leurs renseignements personnels dans un format structuré, couramment utilisé et
            lisible par machine, et (ou) transmettre ces données à un autre contrôleur de données;
            et de
          </Typography>
          <Typography component="li">
            retirer à tout moment leur consentement au traitement de leurs renseignements
            personnels.
          </Typography>
        </Typography>

        <Typography variant="body02">
          Si vous voulez exercer vos droits liés aux données ou si vous avez des questions sur les
          façons dont nous traitons vos renseignements personnels, veuillez communiquer avec nous
          comme indiqué à la section « Comment communiquer avec nous » de la section 12 de la
          présente {privacyPolicyLink('Politique de confidentialité')}.{' '}
        </Typography>
      </Container>
    </div>
  );
};

export default PrivacySpecificRoute;
